<div class="credit-card__container">
    <div class="credit-card" #creditCardRef>
        <div class="credit-card__front" #creditCardFrontRef>
            <div class="credit-card__logo" #creditCardLogoRef></div>
            <div class="credit-card__content">
                <div class="credit-card__chip"></div>
                <div class="credit-card__numbers" #creditCardNumbersRef>
                    {{ creditCardNumber ? creditCardNumber :
                    labelInitialCardNumber ? labelInitialCardNumber :
                    initialConfig?.cardFront?.labelInitialCardNumber }}
                </div>
                <div class="credit-card__footer">
                    <div class="credit-card__person-name" #creditCardPersonNameRef>
                        {{ creditCardPersonName ? creditCardPersonName :
                        labelInitialPersonName ? labelInitialPersonName :
                        initialConfig?.cardFront?.labelInitialPersonName }}
                    </div>
                    <div class="credit-card__expiration-date">
                        <div class="credit-card__valid-until">{{labelValidUntilText ? labelValidUntilText
                            :initialConfig.cardFront?.labelValidUntilText}}</div>
                        <div class="credit-card__month-year">{{labelMonthYear ? labelMonthYear :
                            initialConfig.cardFront?.labelMonthYear}}</div>
                        <div class="credit-card__digit-month-year" #creditCardMonthYearRef>
                            {{creditCardDateValid ? creditCardDateValid :
                            labelInitialDateValid ? labelInitialDateValid :
                            initialConfig?.cardFront?.labelInitialDateValid}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="credit-card__back" #creditCardBackRef>
            <div class="credit-card__bar"></div>
            <div class="credit-card__cvc">
                <span #creditCardCVCRef class="credit-card__cvc-txt">
                    {{creditCardCVC ? creditCardCVC : labelInitialCVC ?
                    labelInitialCVC : initialConfig?.cardBack?.labelInitialCVC }}
                </span>
            </div>
            <div class="credit-card__footer">
                <div class="credit-card__chip-back"></div>
                <div class="credit-card__text-footer">{{labelTextFooter ? labelTextFooter
                    :initialConfig?.cardBack?.labelTextFooter}}</div>
            </div>
        </div>
    </div>
</div>



<ng-content></ng-content>